import React, { useState } from 'react';
import axios from 'axios';
import { ShieldCheck, PiggyBank, Gift, TrendingUp, ArrowRight, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent } from "../ui/dialog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const TOUR_STEPS = [
  { icon: ShieldCheck, color: "bg-amber-100 text-amber-600", title: "1. Verifica tu identidad", text: "Registra tu CURP como tutor y sube tu INE. Así garantizamos que solo la familia administre la alcancía de cada menor." },
  { icon: PiggyBank, color: "bg-brand-lightBlue text-brand-blue", title: "2. Crea la alcancía de tu hijo", text: "Captura su nombre completo, fecha de nacimiento y CURP. Cada alcancía recibe un número de cuenta único para compartir." },
  { icon: Gift, color: "bg-brand-lightGreen text-brand-dark", title: "3. Invita padrinos y familia", text: "Comparte el número de cuenta o envía un regalo por correo o WhatsApp. Ellos aportan una vez, cada mes o cada año." },
  { icon: TrendingUp, color: "bg-brand-dark/10 text-brand-dark", title: "4. Mira crecer el fondo", text: "Fija una meta, revisa el historial y recibe cada mes un resumen con cuánto creció la alcancía y quién aportó." },
];

export const WelcomeTour = ({ open, onClose, userName }) => {
  const [step, setStep] = useState(0);
  const current = TOUR_STEPS[step];
  const Icon = current.icon;
  const last = step === TOUR_STEPS.length - 1;

  const finish = async () => {
    onClose();
    try { await axios.put(`${BACKEND_URL}/api/auth/me/onboarding`, { onboarding_seen: true }); } catch { /* no-op */ }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) finish(); }}>
      <DialogContent className="sm:max-w-lg p-0 overflow-hidden rounded-3xl" data-testid="welcome-tour">
        <div className="bg-brand-dark text-white px-8 pt-8 pb-6 relative overflow-hidden">
          <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full bg-brand-blue/40 blur-2xl" />
          <p className="text-xs uppercase tracking-[3px] font-bold text-brand-green flex items-center gap-1 relative"><Sparkles className="w-3.5 h-3.5" /> Bienvenida</p>
          <h2 className="text-2xl font-extrabold mt-1 relative">{step === 0 ? `¡Hola${userName ? `, ${userName}` : ""}! Así funciona Appadrino` : "Tu ruta en 4 pasos"}</h2>
        </div>
        <div className="px-8 py-6 space-y-5">
          <div key={step} className="flex gap-4 items-start animate-fade-in-up">
            <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 ${current.color}`}><Icon className="w-6 h-6" /></div>
            <div>
              <h3 className="font-bold text-brand-dark text-lg" data-testid="tour-step-title">{current.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mt-1">{current.text}</p>
            </div>
          </div>
          <div className="flex items-center justify-between pt-2">
            <div className="flex gap-1.5" data-testid="tour-dots">
              {TOUR_STEPS.map((_, i) => <button key={i} onClick={() => setStep(i)} aria-label={`Paso ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === step ? "w-8 bg-brand-blue" : "w-3 bg-gray-200"}`} />)}
            </div>
            <div className="flex gap-2">
              {!last && <Button variant="ghost" onClick={finish} data-testid="tour-skip-btn" className="text-gray-500">Saltar</Button>}
              <Button onClick={last ? finish : () => setStep(step + 1)} data-testid="tour-next-btn" className="bg-brand-blue text-white font-bold rounded-full px-5">
                {last ? "¡Empezar!" : "Siguiente"} <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
